import MenuPage from "./components/MenuPage";
import "./App.css";

function App() {
  return <MenuPage />;
}

export default App;
